import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';
import { isSentryEnabled } from './app/core/config/sentry-enabled';

if (environment.production) {
  enableProdMode();
}

if (isSentryEnabled()) {
  Sentry.init({
    dsn: 'https://b1b1b2a2c894d62e7df802fc9a59385c@o4504466001100800.ingest.us.sentry.io/4509917530095616',
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.captureConsoleIntegration({
        levels: ['error'],
      }),
    ],
    release: environment.version,
    environment: environment.name,
    tracesSampleRate: environment.name === 'production' ? 0.5 : 1,
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/api\.guedder\.com/,
      /^https:\/\/dev-api\.guedder\.com/,
      /^https:\/\/guedder-api\.daniloromano\.dev/,
      /^\/(api|auth|config)/,
    ],
    ignoreErrors: [
      "Error: Object of type 'NSObject' has no length",
      "undefined is not an object (evaluating 'window.webkit.messageHandlers'",
      '[GSI_LOGGER]',
      '404 OK',
      'WINDOW.GOOGLE',
      'WINDOW.FB',
      'WINDOW.APPLE',
      // MatIcon reports SVG fetches that got no response (status 0: network
      // dropped, webview backgrounded, navigation aborted the XHR). It's
      // client-side noise; real failures (404/5xx) still get reported.
      /Error retrieving icon .*: 0 Unknown Error/,
      // XHR aborted before a response arrived (network drop, page navigation,
      // webview backgrounded). Client-side noise; subscribe() has no error
      // handler so Angular's global ErrorHandler would otherwise report it.
      'Http failure response for (unknown url): 0 Unknown Error',
    ],
  });

  Sentry.setTag('guedder-ng-version', environment.version);
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
